import React, { useEffect, useRef } from "react";
import * as THREE from "three";
import Project from "./Project";

export default function VantaBackground() {
  const vantaRef = useRef(null);
  const vantaEffect = useRef(null);

  useEffect(() => {
    import("vanta/dist/vanta.rings.min").then((VANTA) => {
      if (!vantaEffect.current) {
        vantaEffect.current = VANTA.default({
          el: vantaRef.current,
          THREE: THREE,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.0,
          minWidth: 200.0,
          scale: 1.0,
          scaleMobile: 1.0,
        });
      }
    });

    return () => {
      if (vantaEffect.current) vantaEffect.current.destroy();
    };
  }, []);

  return (
    <div>
      {/* Vanta animation container */}
      <div
        ref={vantaRef}
        style={{
          width: "98%",
          height: "60vh",
          margin: "0 auto",        // centers the div
          borderRadius: "25px",    // rounded corners
          overflow: "hidden",      // ensures animation stays inside rounded corners
          top: "-40px",
        }}
      >
        <h1
          style={{
            textAlign: "center",
            lineHeight: "60vh",
            color: "white",
            margin: 0,
          }}
        >
          {/* My Projects */}
        </h1>
      </div>

      {/* Projects below Vanta */}
      <div style={{ padding: "2rem", position:"relative", top:"-350px", zIndex:"2" }}>
        <Project />
      </div>
    </div>
  );
}
